import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { OffsidebarComponent } from './offsidebar/offsidebar.component';

import { SharedModule } from '../shared/shared.module';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { UserblockService } from './sidebar/userblock/userblock.service';

@NgModule({
  declarations: [LayoutComponent, FooterComponent, HeaderComponent, SidebarComponent, OffsidebarComponent, UserblockComponent],
  imports: [
    SharedModule
  ],
  providers: [
    UserblockService
  ],
  exports: [
    LayoutComponent,
    SidebarComponent,
    UserblockComponent,
    HeaderComponent,
    //  NavsearchComponent,
    OffsidebarComponent,
    FooterComponent
  ]
})
export class LayoutModule { }
